import { UserProfile } from '@/types/legacyUserProfile';

export enum ActionTypes {
  FETCH_USER_PROFILE_START = 'userProfile/FETCH_USER_PROFILE_START',
  FETCH_USER_PROFILE_SUCCESS = 'userProfile/FETCH_USER_PROFILE_SUCCESS',
  FETCH_USER_PROFILE_FAIL = 'userProfile/FETCH_USER_PROFILE_FAIL',
  CLEAN_USER_PROFILE = 'userProfile/CLEAN_USER_PROFILE',
}

export interface State {
  isLoading: boolean;
  error: string;
  data?: UserProfile;
}

export interface FetchUserProfileStartAction {
  type: ActionTypes.FETCH_USER_PROFILE_START;
}
export interface FetchUserProfileSuccessAction {
  type: ActionTypes.FETCH_USER_PROFILE_SUCCESS;
  payload: UserProfile;
}
export interface FetchUserProfileFailAction {
  type: ActionTypes.FETCH_USER_PROFILE_FAIL;
  payload: string;
}

export interface cleanUserProfileAction {
  type: ActionTypes.CLEAN_USER_PROFILE;
}

export type ActionType =
  | FetchUserProfileStartAction
  | FetchUserProfileSuccessAction
  | FetchUserProfileFailAction
  | cleanUserProfileAction;
